module.exports = __webpack_public_path__ + "static/00066.69272e78.jpg";